<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchLoad">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide" class="search-content common-search-formtype">
          <el-form :inline="true" :model="formInlineTmp" label-width="95px" class="search-content-item">
            <el-form-item label="编号:">
              <el-input v-model.trim="formInlineTmp.dealer_code" placeholder="请输入编号查询" type="text" style="line-height: 60px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="名称:">
              <el-input v-model.trim="formInlineTmp.dealer_name" placeholder="请输入名称查询" type="text" style="line-height: 60px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号:">
              <el-input v-model.trim="formInlineTmp.mobile" placeholder="请输入手机号查询" type="text" style="line-height: 60px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="排序:">
              <el-select v-model="formInlineTmp.sort" placeholder="请选择" clearable>
                <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right" style="">
        <el-button type="primary" class="add-btn" @click="excelImportShow = true" style="float: right;margin-right: 32px;">导入订单</el-button>
        <el-button type="primary" class="add-btn" @click="excelImportShow1 = true" style="float: right;margin-right: 32px;">导入经销商</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table :data="tableData" v-loading="loading" class="table">
        <el-table-column label="经销商编号" align="center" width="120">
          <template slot-scope="scope">
            {{ scope.row.dealer_code }}
          </template>
        </el-table-column>
        <el-table-column label="经销商名称">
          <template slot-scope="scope">
            {{ scope.row.dealer_name }}
          </template>
        </el-table-column>
        <el-table-column label="手机号">
          <template slot-scope="scope">
            {{ scope.row.mobile }}
          </template>
        </el-table-column>
        <el-table-column label="可用余额">
          <template slot-scope="scope">
            {{ scope.row.balance }}
          </template>
        </el-table-column>
        <el-table-column label="提现总额">
          <template slot-scope="scope">
            {{ scope.row.cash_out_total }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="200">
          <template slot-scope="scope">
            {{ scope.row.create_time_text }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <div class="op-link" @click="pushToSubPage(scope.row.id)">
              子账户
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination class="table-foot-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-row>

    <el-dialog title="导入订单" :visible.sync="excelImportShow">
      <el-upload
              class="upload-demo"
              :headers = "header"
              :action="apiHost + 'yunxiao/dealer/importOrder'"
              :auto-upload="true"
              :on-success="handleFileSuccess"
              :before-upload="beforeUpload">
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        <div slot="tip" class="el-upload__tip" style="width: auto; text-align: center;">只能上传excel文件，选择文件后自动上传</div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="excelImportShow = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入经销商" :visible.sync="excelImportShow1">
      <el-upload
              class="upload-demo"
              :headers = "header"
              :action="apiHost + 'yunxiao/dealer/importdealer'"
              :auto-upload="true"
              :on-success="handleFileSuccess"
              :before-upload="beforeUpload">
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        <div slot="tip" class="el-upload__tip" style="width: auto; text-align: center;">只能上传excel文件，选择文件后自动上传</div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="excelImportShow1 = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Lockr from 'lockr'
import { API_HOST } from '@/api/local'
import { getYxDealer, deleteYxQa, createYxQa, getYxQaDetail, editYxQa, importDealerExcel } from '@/api/yunxiao.js'
export default {
  name: 'list',
  data () {
    return {
      loading: true,
      formInlineTmp:{},
      formInline: {
        dealer_code:'',
        dealer_name:'',
        mobile:'',
      },
      options: [
        {
          value: 'balance',
          label: '可用余额'
        }, {
          value: 'cash_out_total',
          label: '提现总额'
        }
      ],
      hide: true,
      tableData: [],
      page: 1,
      totalCount: 0,
      limit: 10,
      excelImportShow: false,
      excelImportShow1: false,
      apiHost: API_HOST,
      header: {
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId')
      }
    }
  },
  methods: {
    searchLoad() {
      this.page = 1
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.getData()
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
    },
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    getData() {
      this.loading = true
      getYxDealer(this.page, this.formInline).then(res => {
        this.tableData = res.data.data.list
        this.totalCount = res.data.data.count
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    pushToSubPage(id) {
      router.push({ name: 'yxdealersub', query: { id: id } })
    },
    beforeUpload(file){
      //console.log('file', file)
      //console.log('fileList', fileList)
      this.files = file
      const extension = file.name.split('.')[1] === 'xls'
      const extension2 = file.name.split('.')[1] === 'xlsx'
      if (!extension && !extension2) {
        _g.toastMsg('error', '上传文档只能是 xls、xlsx格式!')
        return false
      }
    },
    handleFileSuccess(res, file) {
      //console.log(res)
      if (res.code === 0) {
        _g.toastMsg('success', '导入成功：' + res.data.import_num + '条')
      } else {
        _g.toastMsg('error', res.error)
      }
    },
  },
  created() {
    this.getData()
  },
  computed: {
    uploadURL() {
      return API_HOST + 'yunxiao/dealer/importOrder'
    }
  },
  components: {
  }
}
</script>

<style scoped>

</style>
